<template>
    <div id="app">
        <v-app id="inspire">
            <v-content>
                <v-container class="fill-height" fluid>
                    <v-row class="no-app__row" align="center" justify="center">
                        <div>
                            <p>
                                Unfortunately, the lights can only be controlled by people who are actually at the house.
                            </p>
                            <p>
                                <strong>There are two ways to show you're at the house:</strong>
                                <br />
                                <ul>
                                    <li>Allow access to location data, which can admittedly be tricky on some devices<span v-if="oldDevice"> (and might also be hard for your device as it appears it might not be able to provide location data)</span></li>
                                    <li>Scan the QR code on the sign at the house (hopefully it's still there, I have had to tape on a new one 🤦)</li>
                                </ul>
                            </p>
                            <p>
                                <em>If you use the QR code to access the app, you'll need to make sure to use the QR code each time you visit. The app is intentionally not going to "remember" your previous visits</em>
                            </p>
                        </div>
                    </v-row>
                </v-container>
            </v-content>
        </v-app>
    </div>
</template>

<script>
  export default {
    name: "NoApp",
    props: [
      'oldDevice'
    ],
    created() {
      this.$vuetify.theme.dark = true
    }
  }
</script>

<style lang="scss">
    .no-app__row {
        display: block;
        margin: 0 auto;
    }
</style>
